import { getConditionalObject } from 'utils/data';

import {
  THUMBNAIL_BORDER_WIDTH,
  THUMBNAIL_MAX_CONTENT_WIDTH,
  THUMBNAIL_MIN_CONTENT_HEIGHT,
} from './PdfCard.constants';

// The app is globally border-box; the canvas box (width + aspect-ratio) must describe the
// page raster alone, so the thumbnail border sits outside it. A page with no raster yet
// (or a released one) shows blank paper; the clip keeps the thumbnail border transparent.
export const getPdfCardStyles = ({ theme, isSelected, isThumbnail, cssBox }) => ({
  boxSizing: 'content-box',
  backgroundColor: theme.palette.common.white,
  backgroundClip: 'content-box',
  transition: 'border-color 0.15s',
  ...getConditionalObject(isThumbnail, () => ({
    border: `${THUMBNAIL_BORDER_WIDTH}px solid ${
      isSelected ? theme.palette.secondary.main : 'transparent'
    }`,
    maxWidth: THUMBNAIL_MAX_CONTENT_WIDTH,
    minHeight: THUMBNAIL_MIN_CONTENT_HEIGHT,
  })),
  ...cssBox,
});
